<template>
	<el-select v-model="myselected" @change="changeSelect">
		<el-option v-for="item in myoptions" :key="item.vid" :label="item.name" :value="item.vid"></el-option>
	</el-select>
</template>

<script>
export default {
	name:'myselect',
	props:['myoptions','pid','myValue'],
	data(){
		return {
			myselected:this.myValue
		}
	},
	watch:{
	},
	methods:{
		changeSelect(){
			this.$emit("changeSelect",this.pid,this.myselected);
		}
	}
}
</script>

<style>
</style>